import { BehaviorSubject, Observable } from 'rxjs'
import { FacilityUtilisation } from '../facility-utilisation'
import { tap } from 'rxjs/operators'
import { WorkCenterUtilisation } from '../../work-center-utilisation'
import { Facility } from '../../../../facilities/facility'

export class AsyncFacilityUtilisation {
  public state = AsyncFacilityUtilisationState.IDLE
  public readonly utilisation$ = new BehaviorSubject<FacilityUtilisation>(null)

  constructor(
    public facility: Facility,
    private requestFn: () => Observable<FacilityUtilisation>
  ) {}

  public updateRequestFn(requestFn: () => Observable<FacilityUtilisation>): void {
    this.requestFn = requestFn
  }

  public start(): Observable<FacilityUtilisation> {
    return this.requestFn().pipe(
      tap((util) => {
        this.utilisation$.next(util)
        this.state = AsyncFacilityUtilisationState.IDLE
      })
    )
  }

  public getMostUtilizedWC(amount: number): WorkCenterUtilisation[] {
    const util = this.utilisation$.getValue()
    if (util) {
      return util.workCenterUtilisations
        .sort((wcu1, wcu2) =>
          wcu2.capacityUsage > wcu1.capacityUsage
            ? 1
            : -1 || wcu1.workCenterNumber.localeCompare(wcu2.workCenterNumber)
        )
        .slice(0, amount)
    }
    return []
  }

  public hasUnassigned(): boolean {
    const util = this.utilisation$.getValue()
    if (util) {
      return util.unassigned.itemCount > 0
    }
    return false
  }

  public hasOvercapacity(): boolean {
    const util = this.utilisation$.getValue()
    if (util) {
      const mostUtilized = this.getMostUtilizedWC(1)
      if (mostUtilized.length > 0) {
        return mostUtilized[0].capacityUsage > 1
      }
    }
    return false
  }
}

export enum AsyncFacilityUtilisationState {
  LOADING = 'LOADING',
  IDLE = 'IDLE',
}
